import type { FireIconProps } from './types';

export default function SmokeDetector({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Ceiling line */}
      <line x1="2" y1="3" x2="22" y2="3" />
      {/* Detector body (dome) */}
      <path d="M6 3v1a6 6 0 0 0 12 0V3" />
      {/* LED indicator */}
      <circle cx="12" cy="7" r="1" />
      {/* Smoke wisps */}
      <path d="M9 13c0-1 1-2 1-3" />
      <path d="M12 14c0-1.5 1.5-2.5 1.5-4" />
      <path d="M15 13c0-1 1-2 1-3" />
      {/* More smoke */}
      <path d="M8 17c0-1 1.5-2 1.5-3.5" />
      <path d="M12 18c0-1.5 1.5-2 1.5-3.5" />
      <path d="M16 17c0-1 1.5-2 1.5-3.5" />
    </svg>
  );
}
